export default __webpack_public_path__ + "static/media/shopini-economy.14756738.svg";